import { FC, useEffect, useState } from 'react'
import PartofSpeechApi from '../../../../infrastructure/api/PartofSpeechApi'
import { IPartofSpeechModel } from '../../../../models/responses/PartofSpeechModel'
import { PagedResponseModel } from '../../../../models/responses/PagedResponseModel'
import { IPaginationFilter } from '../../../../models/requests/PaginationFilter'
import { GenericTable } from '../../../components/tables/GenericTable'
import { TableHelperButtons } from '../../../components/buttons/TableHelperButtons'
import { TableHelperButtonEnum } from '../../../enums/TableHelperButtonEnum'
import { LanguageEnum } from '../../../../enums/LanguageEnum'

type Props = {
  onClickItem: (itemId: any, itemName: string, type: string) => void
  refresh: number
}

const PartofSpeechListModal: FC<Props> = ({ onClickItem, refresh }) => {
  const [partofSpeechs, setPartofSpeechs] = useState<PagedResponseModel<IPartofSpeechModel[]>>()
  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [searchText, setSearchText] = useState('')
  const [sort, setSort] = useState('name_asc')

  useEffect(() => {
    const paginationFilter: IPaginationFilter = {
      page: pageNumber,
      size: pageSize,
      orderBy: sort,
      search: searchText,
    }
    async function getPartofSpeechs() {
      var response = await PartofSpeechApi.GetPartofSpeechs(paginationFilter)
      setPartofSpeechs(response.data)
    }
    getPartofSpeechs()
  }, [refresh, pageNumber, pageSize, searchText, sort])

  return (
    <>
      <GenericTable
        title='Part of Speechs'
        data={partofSpeechs?.items}
        currentTotalRecords={partofSpeechs?.totalRecords!!}
        currentPageNumber={partofSpeechs?.pageNumber!!}
        columns={[
          {
            label: '#',
            name: '#',
            options: {
              customBodyRenderLite: (dataIndex) => {
                return <>{(pageNumber - 1) * pageSize + ++dataIndex}</>
              },
              sort: false,
              viewColumns: false,
            },
          },
          {
            label: 'Name',
            name: 'name',
            options: {
              customBodyRender: (value) => {
                return <b>{value}</b>
              },
            },
          },
          {
            label: 'Display Name',
            name: 'displayName',
          },
          {
            label: 'Language',
            name: 'languageId',
            options: {
              customBodyRender: (value) => {
                return <div className='d-flex align-items-center'>{LanguageEnum[value]}</div>
              },
            },
          },
          {
            label: '#',
            name: 'Id',
            options: {
              customHeadLabelRender: (options) => {
                return (
                  <div className='d-flex justify-content-end flex-shrink-0'>{options.label}</div>
                )
              },
              customBodyRenderLite: (dataIndex) => {
                return (
                  <TableHelperButtons
                    itemId={partofSpeechs?.items[dataIndex]?.id!!}
                    itemParam={partofSpeechs?.items[dataIndex]?.name!!}
                    types={[TableHelperButtonEnum.Update, TableHelperButtonEnum.Delete]}
                    onClickItem={onClickItem}
                  />
                )
              },
              filter: false,
              sort: false,
              viewColumns: false,
            },
          },
        ]}
        customOptions={{
          rowsPerPage: pageSize,
          customTableBodyFooterRender: (opts) => {
            return <div></div>
          },
        }}
        setPageNumber={setPageNumber}
        setPageSize={setPageSize}
        setSearchText={setSearchText}
        setSort={setSort}
      />
    </>
  )
}

export { PartofSpeechListModal }
